export const PUBLIC_IMAGE = "/image/";
export const PUBLIC_ICON = "/icons/";